module.exports = __webpack_public_path__ + "img/step2.3ae2a5b5.svg";